import Line from '@FreeRider/Track/Lines/Line';
import Mass from '@FreeRider/Physics/Mass';

class PhysicsLine extends Line
{
    /**
     * Calculates the collision of mass object with line
     * @param mass
     */
    public collide(mass: Mass)
    {
        if (this.collided)
        {
            return;
        }

        this.collided = true;

        const m = mass.position;
        const v = mass.vel;
        const r = mass.radius;

        let dX = 0;
        let dY = 0;
        let dl = 0;

        const mp1X = m.x - this.p1x;
        const mp1Y = m.y - this.p1y;

        const ppX = this.ppx;
        const ppY = this.ppy;
        const len = this.len;

        const k = ((mp1X * ppX) + (mp1Y * ppY)) / len / len;
        let mFactor;
        if (k >= 0 && k <= 1)
        {
            const cross = (mp1X * ppY - mp1Y * ppX) * ((mp1X - v.x) * ppY - (mp1Y - v.y) * ppX) < 0 ? -1 : 1;
            dX = mp1X - (ppX * k);
            dY = mp1Y - (ppY * k);

            dl = Math.sqrt(Math.pow(dX, 2) + Math.pow(dY, 2));

            if (dl === 0)
            {
                dl = 1;
            }

            if (dl < r || cross < 0)
            {
                mFactor = ((r * cross - dl) / dl);
                m.x += dX * mFactor;
                m.y += dY * mFactor;
                mass.drive(-dY / dl, dX / dl);
                return;
            }

        }

        if (k * len < -r || k * len > len + r)
        {
            return;
        }

        var endX = k > 0 ? this.p2x : this.p1x;
        var endY = k > 0 ? this.p2y : this.p1y;

        dX = m.x - endX;
        dY = m.y - endY;

        dl = Math.sqrt(Math.pow(dX, 2) + Math.pow(dY, 2));

        if (dl === 0)
        {
            dl = 1;
        }

        if (dl < r)
        {
            mFactor = (r - dl) / dl;
            m.x += dX * mFactor;
            m.y += dY * mFactor;

            mass.drive(-dY / dl, dX / dl);
            return;
        }
    }
}

export default PhysicsLine;